import angular from 'angular';

let CardListController = function (Card, $filter, $scope, $state, $mdDialog, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;

  angular.extend($ctrl, {
    edit, orderList, handleDelete
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'name',
      like_search: '',
      like_search_fields: [
        'name'
      ]
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }

  function edit(id) {
    $state.go('card.edit', {id});
  }

  function handleDelete(resource, event) {
    event.stopPropagation();

    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('common-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('common-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Card
          .destroy(resource)
          .then(response => {
            Toast.success($filter('translate')('common-detail-delete-success'));
            $ctrl.deleting = false;
            _.remove($ctrl.resources.data, resource);
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function orderList(field) {
    var tableConfig = $ctrl.$scope.tableConfig;
    if (tableConfig.order) {
      var currentField = tableConfig.order.split(' ')[0];
      var currentOrder = tableConfig.order.split(' ')[1];
      
      if (currentField === field) {
        currentOrder = currentOrder === 'DESC' ? 'ASC' : 'DESC';
        tableConfig.order = currentField + ' ' + currentOrder;  
      } else {
        tableConfig.order = field + ' ' + 'ASC'; 
      }
    } else {
      tableConfig.order = field + ' ' + ' ASC';
    }
  }

  // Local functions

  function loadData() {
    $ctrl.promise = Card
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.description === null || item.description === undefined) {
  			item.description = $filter('translate')('common-not-informed');
  		}
  	});
  }
}

CardListController.$inject = ['Card', '$filter', '$scope', '$state', '$mdDialog', 'Toast'];

export default CardListController;



// WEBPACK FOOTER //
// ./client/app/components/card/card-list.controller.js